const DeptFund = () => import(/* webpackChunkName: "manager" */ './DeptFund');

export default {
    routes: [
        {
            path: '/deptfund/index',
            name: 'DeptFund',
            component: DeptFund
        }
    ]
}
